// extracted by mini-css-extract-plugin
module.exports = {"modal":"IEvJg8","products":"_1ekHZs","product":"_3cjBF-","button":"_3hJyPe","loader":"_32ioXr"};